<template>
<div class="wrapper">
  <NavBar v-on:updateBalance="handleBalance" />

  <section class="hero hero-border is-small is-primary is-bold section-padding">
    <div class="hero-body">
      <div class="container">
        <div class="row">
          <h1 class="title">
            Your Wallet Balance
          </h1>
        </div>
        <br>
        <div class="row is-padded">
          <div class="columns is-mobile">
            <div class="column is-one-fifth" style="margin: auto;">
              <img src="https://image.flaticon.com/icons/svg/2586/2586005.svg" style="height: 50px;" />
            </div>
            <div class="column is-third-fifth" style="margin: auto;">
              <p style=""> {{ ethBalance | numberWithCommas }} </p>
            </div>
            <div class="column is-one-fifth" style="margin: auto;">
              ETH
            </div>
          </div>
        </div>
        <div class="row is-padded">
          <div class="columns is-mobile">
            <div class="column is-one-fifth" style="margin: auto;">
              <img src="https://image.flaticon.com/icons/svg/2089/2089411.svg" style="height: 50px;" />
            </div>
            <div class="column is-third-fifth" style="margin: auto;">
              <p> {{ ERC20Balance | numberWithCommas }} </p>
            </div>
            <div class="column is-one-fifth" style="margin: auto;">
              <p> {{ ERC20Symbol }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-padding is-orange">
    <div class="columns is-multiline is-mobile is-3">

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button">
          <a @click="isSendModalActive=true">
            <div class="card-image">
              <figure class="image is-2by1">
                <img src="https://image.flaticon.com/icons/svg/563/563284.svg" alt="Placeholder image">
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-4">SEND</p>
                  <p class="subtitle is-6">Send crypto to your friends</p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button">
          <a @click="isQRCodeModalActive=true">
            <div class="card-image">
              <figure class="image is-2by1">
                <img src="https://image.flaticon.com/icons/svg/825/825569.svg" alt="Placeholder image">
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-4">RECEIVE</p>
                  <p class="subtitle is-6">Receive crypto from your friends</p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button">
          <a @click="isBuyModalActive=true">
            <div class="card-image">
              <figure class="image is-2by1">
                <img src="https://image.flaticon.com/icons/svg/1727/1727786.svg" alt="Placeholder image">
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-4">BUY TOKEN</p>
                  <p class="subtitle is-6">Get tokens pay with your crypto </p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button">
          <a @click="isCheckinModalActive=true">
            <div class="card-image">
              <figure class="image is-2by1">
                <img src="https://image.flaticon.com/icons/svg/762/762123.svg" alt="Placeholder image">
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-4">CHECK-IN</p>
                  <p class="subtitle is-6">Check-in Your location and get tokens </p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button-inactive">
          <!-- <a @click="isPaymentModalActive=true"> -->
          <div class="card-image">
            <figure class="image is-2by1">
              <img src="https://image.flaticon.com/icons/svg/2145/2145444.svg" alt="Placeholder image">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">PAYMENT</p>
                <p class="subtitle is-6">Pay with your cryptos</p>
              </div>
            </div>
          </div>
          <!-- </a> -->
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button-inactive">
          <div class="card-image">
            <figure class="image is-2by1">
              <img src="https://image.flaticon.com/icons/svg/1936/1936026.svg" alt="Placeholder image">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">TRADING</p>
                <p class="subtitle is-6">Atomic swap for other cryptos</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button-inactive">
          <div class="card-image">
            <figure class="image is-2by1">
              <img src="https://image.flaticon.com/icons/svg/2300/2300356.svg" alt="Placeholder image">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">INSURANCE</p>
                <p class="subtitle is-6">Get Insurance on smart contracts </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button-inactive">
          <div class="card-image">
            <figure class="image is-2by1">
              <img src="https://image.flaticon.com/icons/svg/888/888376.svg" alt="Placeholder image">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4 is-mobile">LOAN</p>
                <p class="subtitle is-6">Apply for loan using your crypto</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button-inactive">
          <div class="card-image">
            <figure class="image is-2by1">
              <img src="https://image.flaticon.com/icons/svg/2193/2193414.svg" alt="Placeholder image">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">LOTTO</p>
                <p class="subtitle is-6"> Try your lucks and win cryptos </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-one-fifth-desktop is-one-third-tablet is-half-mobile is-btn">
        <div class="card card-button-inactive">
          <div class="card-image">
            <figure class="image is-2by1">
              <img src="https://image.flaticon.com/icons/svg/2006/2006255.svg" alt="Placeholder image">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4 is-mobile"> BET </p>
                <p class="subtitle is-6"> Bet on sport events with cryptos </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

  <section class="section-padding">
    <div class="content has-text-centered">
      <h1 class="title"> Cryptocurrency Prices </h1>
      <b-table :mobile-cards="true" :data="cryptoData" :sticky-header="true">
        <template slot-scope="props" label="Rank">
          <b-table-column field="rank" numeric>
            {{ props.row.rank }}
          </b-table-column>

          <b-table-column field="icon" label="Token Name">
            <img class="icon" :src="props.row.icon" />
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="price" label="Price $" centered>
            <span v-if="props.row.change > 0" class="tag is-success">
              {{ props.row.price }}
            </span>
            <span v-if="props.row.change <= 0" class="tag is-danger">
              {{ props.row.price }}
            </span>
          </b-table-column>

          <b-table-column field="change" label="% Change" centered>
            <span v-if="props.row.change > 0">
              <b-icon icon="arrow-up" type="is-success"></b-icon>
              <span class="tag is-succes">
                {{ props.row.change }} %
              </span>
            </span>

            <span v-if="props.row.change <= 0">
              <b-icon icon="arrow-down" type="is-danger"></b-icon>
              <span class="tag is-danger">
                {{ props.row.change }} %
              </span>
            </span>
          </b-table-column>

        </template>
      </b-table>
    </div>
  </section>

  <footer class="footer hero is-orange">
    <div class="content has-text-centered">
      <p>
        <strong>DEFI Wallet </strong> <br>
        <strong> Made with <i class="fas fa-heart has-text-danger"></i> </strong> by <a href="https://www.iyawat.com"> Iyawat Kongmalai </a>
      </p>
    </div>
  </footer>

  <div class="wrapper-inline">

    <b-modal :active.sync="isSendModalActive">
      <div class="container modal-container">
        <section>
          <h1 class="modal-title"> Account # </h1>
          <h1 class="modal-subtitle is-text-smaller" @click="copyText(web3.coinbase)"> {{ web3.coinbase }} &nbsp;
            <i class="fas fa-copy has-text-warning" @click="copyText(web3.coinbase)"></i>
          </h1><br>
          <h1 class="modal-title"> {{ ethBalance | numberWithCommas }} ETH </h1>
          <h1 class="modal-title"> {{ ERC20Balance | numberWithCommas }} {{ ERC20Symbol }} </h1>
        </section>
        <section>
          <div class="wallet-body">
            <div class="wallet-box">
              <b-field class="label-head" label="To Address: ">
                <b-input placeholder="Destination Address..." type="textarea" rows="2" maxlength="64" v-model="toAddress">
                </b-input>
              </b-field>
              <qrcode-capture id="file" @decode="onDecode" />
              <label for="file" class="btn-1"> Click to scan QR </label>

              <b-field class="label-head" label="Amount: ">
                <b-input placeholder="Amount..." type="text" pattern="^\d*(\.\d{0,2})?$" v-model="amount">
                </b-input>
              </b-field>

            </div>
          </div>
        </section>
        <section>
          <b-button icon-right="money-bill-wave" class="button-box" @click="checkUsingPassword()">
            Send
          </b-button>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isQRCodeModalActive">
      <div class="container modal-container">
        <section>
          <qrcode-vue :value="web3.coinbase" :size="size" background="#FFFFFF" style="padding: 2rem 10px;" level="H" />
          <h1 class="modal-title"> Account # </h1>
          <h1 class="modal-subtitle is-text-smaller" @click="copyText(web3.coinbase)"> {{ web3.coinbase }} &nbsp;
            <i class="fas fa-copy has-text-warning" @click="copyText(web3.coinbase)"></i>
          </h1><br>
          <h1 class="modal-title"> {{ ethBalance | numberWithCommas }} ETH </h1>
          <h1 class="modal-title"> {{ ERC20Balance | numberWithCommas }} {{ ERC20Symbol }} </h1>
        </section>
        <section>
          <b-button icon-right="times" class="button-box" @click="isQRCodeModalActive = false;">
            Close
          </b-button>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isBuyModalActive">
      <div class="container modal-container">
        <section>
          <h1 class="modal-title"> Account # </h1>
          <h1 class="modal-subtitle is-text-smaller" @click="copyText(web3.coinbase)"> {{ web3.coinbase }} &nbsp;
            <i class="fas fa-copy has-text-warning" @click="copyText(web3.coinbase)"></i>
          </h1><br>
          <h1 class="modal-title"> {{ ethBalance | numberWithCommas }} ETH </h1>
          <h1 class="modal-title"> {{ ERC20Balance | numberWithCommas }} {{ ERC20Symbol }} </h1>
        </section>
        <hr>
        <section>
          <div class="wallet-body">
            <div class="wallet-box">
              <h1 class="modal-title"> CrowdSale Contract # </h1>
              <h1 class="modal-subtitle is-text-smaller"> {{ crowdsaleAddr }} </h1> <br>
              <h1 class="modal-title"> Rate: 1 ETH = {{ exchangeRate }} IceZ </h1> <br>

              <b-field class="label-head" :label="'Enter ETH Amount to exchange : You will get '+this.amount*this.exchangeRate+ ' Tokens'">
                <b-input placeholder="Buy Amount..." type="text" pattern="^\d*(\.\d{0,2})?$" v-model="amount">
                </b-input>
              </b-field>

            </div>
          </div>
        </section>
        <section>
          <b-button icon-right="money-bill-wave" class="button-box" @click="toAddress = 'BuyToken', checkUsingPassword()">
            Send
          </b-button>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isCheckinModalActive">
      <div class="container modal-container">
        <section>
          <h1 class="modal-title"> Account # </h1>
          <h1 class="modal-subtitle is-text-smaller" @click="copyText(web3.coinbase)"> {{ web3.coinbase }} &nbsp;
            <i class="fas fa-copy has-text-warning" @click="copyText(web3.coinbase)"></i>
          </h1><br>
          <h1 class="modal-title"> {{ ethBalance | numberWithCommas }} ETH </h1>
          <h1 class="modal-title"> {{ ERC20Balance | numberWithCommas }} {{ ERC20Symbol }} </h1>
        </section>
        <section>
          <div class="wallet-body">
            <div class="wallet-box">
              <b-field class="label-head" label="Check In Address: ">
                <b-input placeholder="Destination Address..." disabled type="textarea" rows="2" maxlength="64" v-model="toAddress">
                </b-input>
              </b-field>
              <qrcode-capture id="file" @decode="onDecode" />
              <label for="file" class="btn-1"> Click to scan QR </label>

            </div>
          </div>
        </section>
        <section>
          <b-button icon-right="money-bill-wave" class="button-box" @click="checkIn()">
            Check In !
          </b-button>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isPaymentModalActive">
      <div class="container modal-container">
        <section>
          <h1 class="modal-title"> Account # </h1>
          <h1 class="modal-subtitle is-text-smaller" @click="copyText(web3.coinbase)"> {{ web3.coinbase }} &nbsp;
            <i class="fas fa-copy has-text-warning" @click="copyText(web3.coinbase)"></i>
          </h1><br>
          <h1 class="modal-title"> {{ ethBalance | numberWithCommas }} ETH </h1>
          <h1 class="modal-title"> {{ ERC20Balance | numberWithCommas }} {{ ERC20Symbol }} </h1>
        </section>
        <section>
          <div class="wallet-body">
            <div class="wallet-box">
              <b-field class="label-head" label="To Address: ">
                <b-input placeholder="Destination Address..." disabled type="textarea" rows="2" maxlength="64" v-model="toAddress">
                </b-input>
              </b-field>
              <qrcode-capture id="file" @decode="onDecode" />
              <label for="file" class="btn-1"> Click to scan QR </label>

              <b-field class="label-head" label="Amount: ">
                <b-input placeholder="Amount..." disabled type="text" pattern="^\d*(\.\d{0,2})?$" v-model="amount">
                </b-input>
              </b-field>

            </div>
          </div>
        </section>
        <section>
          <b-button icon-right="money-bill-wave" class="button-box" @click="checkUsingPassword()">
            Send
          </b-button>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isLoading">
      <div class="container modal-container">
        <section style="background-color: #FFF; border-radius: 20px 20px 0 0;">
          <img src="img/loading.gif" />
          <img src="https://image.flaticon.com/icons/svg/883/883917.svg" style="width: 100px;" />
        </section>
        <section style="background-color: #FFF; border-radius: 0 0 20px 20px;">
          <h1> L O A D I N G . . . </h1>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isResultModalActive">
      <div class="container modal-container">
        <section>
          <h1 class="modal-title"> Account # </h1>
          <h1 class="modal-subtitle is-text-smaller" @click="copyText(web3.coinbase)"> {{ web3.coinbase }} &nbsp;
            <i class="fas fa-copy has-text-warning" @click="copyText(web3.coinbase)"></i>
          </h1><br>
          <h1 class="modal-title"> {{ ethBalance | numberWithCommas }} ETH </h1>
          <h1 class="modal-title"> {{ ERC20Balance | numberWithCommas }} {{ ERC20Symbol }} </h1>
        </section>
        <section>
          <h1 class="modal-title"> To Account # </h1>
          <h1 class="modal-subtitle is-text-smaller"> {{ toAddress }} </h1>
        </section>
        <section>
          <h1 class="modal-title"> Amount: </h1>
          <h1 class="modal-title"> {{ amount }} ETH </h1>
        </section>
        <section>
          <h1 class="modal-title"> Hash # </h1>
          <a :href="ethscanURL+trfResult" target="_blank">
            <h1 class="modal-subtitle is-smaller"> {{ trfResult }} </h1>
          </a>
        </section>
        <section>
          <b-button icon-right="times" class="button-box" @click="isResultModalActive = false; updateWallet(); amount=0; toAddress=''">
            Close
          </b-button>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isPasswordModalActive">
      <div class="container modal-container">
        <section>
          <p class="modal-text pa-10"> Enter your password: </p>
          <b-field class="label-head">
            <b-input placeholder="password..." type="text" rows="1" maxlength="64" rounded v-model="password">
            </b-input>
          </b-field>
        </section>
        <section>
          <b-button icon-right="money-bill-wave" class="button-box" @click="transferEther(); isPasswordModalActive = false; password = '';">
            Submit
          </b-button>
        </section>
      </div>
    </b-modal>

    <b-modal :active.sync="isErrorModalActive">
      <div class="container modal-container">
        <section>
          <h1 class="modal-title"> ERROR ! </h1>
          <h1 class="modal-subtitle"> {{ error }} </h1>
        </section>
        <section>
          <b-button icon-right="times" class="button-box" @click="isErrorModalActive = false; ">
            Close
          </b-button>
        </section>
      </div>
    </b-modal>

  </div>
</div>
</template>

<script>
import NavBar from '@/components/NavBar'
import SmartContract from '@/util'
import {
  mapState,
  mapActions
} from 'vuex'
import UserDataPersistance from '@/userData/persistance'
import QrcodeVue from 'qrcode.vue'
import {
  QrcodeCapture
} from 'vue-qrcode-reader'
import {
  ToastProgrammatic as Toast
} from 'buefy'

const smartContract = new SmartContract()

export default {
  name: 'home',
  data: () => ({
    usingMetaMask: false,
    contractAddr: '',
    isLoading: false,
    isSendModalActive: false,
    isQRCodeModalActive: false,
    isCheckinModalActive: false,
    isBuyModalActive: false,
    isPaymentModalActive: false,
    isResultModalActive: false,
    isPasswordModalActive: false,
    isErrorModalActive: false,
    password: '',
    size: 250,
    ethBalance: '0',
    balance: '',
    account: '',
    network: [],
    block: [],
    userData: null,
    ERC20Balance: '0',
    decimals: '',
    ERC20Symbol: '-',
    toAddress: '',
    amount: '0',
    trfResult: '',
    cryptoData: [],
    crowdsaleAddr: '',
    exchangeRate: 1000,
    error: null,
    isInLineClient: false,
    ethscanURL: ''
  }),
  components: {
    NavBar,
    QrcodeVue,
    QrcodeCapture
  },
  async mounted() {
    this.userData = new UserDataPersistance()

    let _this = this

    if (this.$liff.isInClient()) {
      this.isInLineClient = true
    }

    axios.get('https://api.coinranking.com/v1/public/coins').then(res => {
      this.cryptoData = res.data.data.coins.map((val) => {
        return {
          'rank': val.rank,
          'icon': val.iconUrl,
          'name': val.name,
          'price': val.price,
          'change': val.change
        }
      })
    })

    setTimeout(function () {
      console.log('NET: ', _this.web3.networkId);
      if (_this.web3.networkId == 'Kovan') {
        _this.crowdsaleAddr = process.env.VUE_APP_CROWDSALE_CONTRACT_ADDR_KOVAN
        _this.ethscanURL = 'https://kovan.etherscan.io/tx/'
      } else if (_this.web3.networkId == 'Rinkeby') {
        _this.crowdsaleAddr = process.env.VUE_APP_CROWDSALE_CONTRACT_ADDR_RINKEBY
        _this.ethscanURL = 'https://rinkeby.etherscan.io/tx/'
      } else if (_this.web3.networkId == 'Thai Chain') {
        _this.crowdsaleAddr = process.env.VUE_APP_CROWDSALE_CONTRACT_ADDR_THAICHAIN
        _this.ethscanURL = 'https://exp.tch.in.th/tx/'
      }
    }, 2500)

  },
  computed: {
    ...mapState({
      web3: state => state.web3,
      wallet: state => state.wallet
    })
  },
  watch: {
    exchangeAmount: function (amt) {
      this.exchangeAmount = this.amount / this.exchangeRate
    }
  },
  filters: {
    numberWithCommas(x) {
      if (x !== undefined && x !== null) {
        let parts = x.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
      }
    },
  },
  methods: {
    ...mapActions({
      updateWeb3: 'updateWeb3',
      createWallet: 'createWallet',
      updateNetworkId: 'updateNetworkId',
      updateBalance: 'updateBalance'
    }),
    async checkIn() {
      let rawData = {
        address: this.web3.coinbase,
        geo: this.geo
      }
      let headers = {
        'Content-Type': 'application/json'
      }
      // console.log('Data: ', rawData, process.env.VUE_APP_SERVER+'/checkin')
      this.isLoading = true
      let result = await axios.post(process.env.VUE_APP_SERVER + '/checkin', rawData, {
        headers: headers
      })
      this.isLoading = false
      this.isCheckinModalActive = false
      this.isResultModalActive = true
      this.trfResult = result.data.transactionHash
      // this.updateWallet()
      this.sendMessage()
      // console.log('Checkin: ', result)
    },
    async checkUsingPassword() {
      if (this.usingMetaMask) {
        this.isPasswordModalActive = false
        this.password = ''
        this.transferEther();
      } else {
        this.isPasswordModalActive = true
      }
    },
    async updateWallet() {
      let _this = this
      this.$parent.$parent.$data.isLoading = true

      this.userData = new UserDataPersistance()

      // this.network = await smartContract.getNetID()
      this.updateNetworkId(this.network.name)
      // this.block = await smartContract.getBlock()

      if (this.network.metamask) {
        this.usingMetaMask = true
      }

      if (this.usingMetaMask) {
        if (this.network.netId != 7) {
          this.account = await smartContract.loadUserAddress()
        } else {
          this.account = this.web3.coinbase
        }
      } else {
        this.account = this.userData.userAddress
        this.loadLocal = true
      }

      if (this.account.address != undefined) {
        this.account = '0x' + this.account.address
      } // Fixed for Thai Chain

      if (this.account) {
        this.updateWeb3({
          'coinbase': this.account,
          'balance': this.balance,
          'mnemonic': this.userData.mnemonic,
          'networkId': this.network.name
        })

        try {
          this.balance = await smartContract.getBalance(this.account)
        } catch {
          this.account = this.userData.balance
        }

        if (this.balance > 0) {
          this.balance = Number(this.balance).toFixed(4)
        }
        this.ethBalance = this.balance
        this.ERC20Balance = await smartContract.getERC20Balance(this.account)
        this.decimals = await smartContract.getERC20Decimals(this.account)
        this.ERC20Balance = (this.ERC20Balance / Math.pow(10, this.decimals)).toFixed(4)
        this.ERC20Symbol = await smartContract.getERC20Symbol(this.account)
        // console.log(this.network, this.balance, this.ERC20Balance, this.ERC20Symbol, this.usingMetaMask);

        _this.$emit('updateBalance', this.balance, this.ERC20Balance, this.ERC20Symbol, this.usingMetaMask)

        if (!this.loadLocal) {
          window.ethereum.on('accountsChanged', async function (accounts) {
            console.log("change", accounts[0])
            this.account = accounts[0]
            this.network = await smartContract.getNetID()
            try {
              this.balance = await smartContract.getBalance(accounts[0])
            } catch {
              this.balance = '0'
            }
            if (this.balance > 0) {
              this.balance = Number(this.balance).toFixed(4)
            }
            this.ethBalance = this.balance
            this.ERC20Balance = await smartContract.getERC20Balance(this.account)
            this.decimals = await smartContract.getERC20Decimals(this.account)
            this.ERC20Balance = (this.ERC20Balance / Math.pow(10, this.decimals)).toFixed(4)
            this.ERC20Symbol = await smartContract.getERC20Symbol(this.account)
            _this.$emit('updateBalance', this.balance, this.ERC20Balance, this.ERC20Symbol, this.usingMetaMask)

            _this.updateWeb3({
              'coinbase': accounts[0],
              'balance': this.balance,
              'networkId': this.network.name
            })
          })
        }
        this.$parent.$parent.$data.isLoading = false
      } else {
        if (this.userData.userAddress) {
          // console.log("Update UserAddress");
          let balance = await smartContract.getBalance(this.userData.userAddress)
          this.updateBalance({
            'address': this.userData.userAddress,
            'balance': balance
          })
          await this.updateUserBalance(balance)
          this.$parent.$parent.$data.isLoading = false
        } else {
          // console.log("Create UserAddress");
          // let account = await smartContract.createAccount()
          // console.log ('Wallet: ', account)

          this.account = await smartContract.generateSeed()
          // console.log('Address & Key from Seed: ', this.account)
          this.seed = this.account.mnemonic
          this.isSeedModalActive = true
          this.$parent.$parent.$data.isLoading = false
        }
      }
    },
    async updateUserBalance(balance) {
      this.userData.updateUserBalance(balance)
      this.userData.save()
    },
    handleBalance(balance, ERC20Balance, ERC20Symbol, usingMetaMask) {
      this.ethBalance = balance
      this.ERC20Balance = ERC20Balance
      this.ERC20Symbol = ERC20Symbol
      this.usingMetaMask = usingMetaMask
      // console.log('MetaMask: ', this.usingMetaMask)
    },
    async updatePersistance(userAddress, balance, mnemonic) {
      this.userData.update(userAddress, balance, mnemonic)
      this.userData.save()
    },
    closeSend() {
      this.isSendModalActive = false
    },
    async transferEther() {
      this.isLoading = true

      let privKey = await smartContract.decPrivateKey(this.web3.mnemonic, this.password)
      if (this.toAddress == "BuyToken") {
        this.toAddress = this.crowdsaleAddr
      }
      let result = await smartContract.transferEther(this.web3.networkId, this.web3.coinbase, privKey, this.toAddress, this.amount)
      // console.log("Transfer ETH: ", result)
      this.isLoading = false
      this.isSendModalActive = false
      this.isBuyModalActive = false
      // this.updateWallet()

      if (result.code || !result.transactionHash) {
        this.error = result.message
        this.isErrorModalActive = true

      } else {

        // alert('LINE: ', this.isInLineClient)
        this.isResultModalActive = true
        this.trfResult = result.transactionHash

        // alert(JSON.stringify(message))
        this.sendMessage()

      }
    },
    onDecode(result) {
      // const qrString = result
      if (result.indexOf('lat=')) {

        let res = result.split('&')
        this.toAddress = res[0].replace('address=', '')
        this.geo = res[1].replace('lat=', '') + ',' + res[2].replace('lng=', '')
        console.log(res, this.geo);
      } else if (result.indexOf('value=')) {
        let res = result.split('ethereum:')
        let res2 = res[1].split('value=')
        let res3 = res2[1].split('&')
        // alert(res, res2, res3)
        this.toAddress = res2[0].replace('?', '')
        this.amount = res3[0]

      } else {
        this.toAddress = result.replace('ethereum:', '')
      }
    },
    sendMessage() {

      let message = ''
      if (this.isInLineClient) {
        message = {
          "type": "flex",
          "altText": "This is a flex message",
          "contents": {
            "type": "bubble",
            "styles": {
              "footer": {
                "separator": true
              }
            },
            "body": {
              "type": "box",
              "layout": "vertical",
              "contents": [{
                  "type": "text",
                  "text": "RECEIPT",
                  "weight": "bold",
                  "color": "#FFCE00",
                  "size": "xxl"
                },
                {
                  "type": "text",
                  "text": "DEFI Wallet Receipt",
                  "weight": "bold",
                  "size": "lg",
                  "margin": "md"
                },
                {
                  "type": "separator",
                  "margin": "md"
                },
                {
                  "type": "box",
                  "layout": "vertical",
                  "margin": "md",
                  "spacing": "sm",
                  "contents": [{
                      "type": "box",
                      "layout": "horizontal",
                      "contents": [{
                        "type": "text",
                        "text": "From:",
                        "size": "lg",
                        "color": "#555555",
                        "flex": 0
                      }]
                    },
                    {
                      "type": "box",
                      "layout": "horizontal",
                      "contents": [{
                        "type": "text",
                        "text": this.web3.coinbase,
                        "wrap": true,
                        "size": "sm",
                        "color": "#FFCE00",
                        "flex": 0
                      }]
                    },
                    {
                      "type": "separator",
                      "margin": "md"
                    },
                    {
                      "type": "box",
                      "layout": "horizontal",
                      "contents": [{
                        "type": "text",
                        "text": "To:",
                        "size": "lg",
                        "color": "#555555",
                        "flex": 0
                      }]
                    },
                    {
                      "type": "box",
                      "layout": "horizontal",
                      "contents": [{
                        "type": "text",
                        "text": this.toAddress,
                        "wrap": true,
                        "size": "sm",
                        "color": "#FFCE00",
                        "flex": 0
                      }]
                    },
                    {
                      "type": "box",
                      "layout": "horizontal",
                      "margin": "xxl",
                      "contents": [{
                          "type": "text",
                          "text": "Amount",
                          "size": "xl",
                          "color": "#FFCE00",
                          "flex": 2
                        },
                        {
                          "type": "text",
                          "text": this.amount,
                          "size": "xl",
                          "weight": "bold",
                          "color": "#FFCE00",
                          "flex": 3
                        },
                        {
                          "type": "image",
                          "url": "https://defi-wallet.iyawat.com/img/ethereum-icon.png",
                          "aspectRatio": "1:1",
                          "size": "xl",
                          "flex": 1
                        }
                      ]
                    }
                  ]
                },
                {
                  "type": "separator",
                  "margin": "md"
                },
                {
                  "type": "box",
                  "layout": "horizontal",
                  "margin": "md",
                  "contents": [{
                      "type": "text",
                      "text": "DATE",
                      "size": "xs",
                      "color": "#aaaaaa",
                      "flex": 0
                    },
                    {
                      "type": "text",
                      "text": new Date().toUTCString(),
                      "color": "#aaaaaa",
                      "size": "xs",
                      "align": "end"
                    }
                  ]
                },
                {
                  "type": "box",
                  "layout": "vertical",
                  "spacing": "sm",
                  "contents": [{
                    "type": "button",
                    "flex": 2,
                    "style": "primary",
                    "color": "#FFCE00",
                    "action": {
                      "type": "uri",
                      "label": "Tx Hash",
                      "uri": this.ethscanURL + this.trfResult
                    }
                  }]
                }
              ]
            }
          }
        }
      }

      this.$liff.sendMessages([message])
        .then(function () {
          Toast.open({
            message: 'Message sent to your line',
            type: 'is-success'
          })
        }).catch(function (error) {
          Toast.open({
            message: 'Error sending message: ' + error,
            type: 'is-danger'
          })
        })

      this.$router.go(0)
    },
    copyText(text) {
      this.$copyText(text).then((e) => {
        Toast.open({
          message: 'Address Copied',
          type: 'is-success'
        })
      }, (e) => {
        Toast.open({
          message: 'Cannot copy address',
          type: 'is-danger'
        })
      })
    },
  }
}
</script>

<style lang="scss">
/* Font */
@import url('https://fonts.googleapis.com/css?family=Quicksand:400,700');

/* Design */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  background-color: #ecf9ff;
}

body {
  // color: #272727;
  // font-family: 'Quicksand', serif;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0;
  padding: 1rem;
}

.main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 5rem;
}

.card-button {
  border-radius: 20px;
  background: #ffe259;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #ffe259, #ffa751);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #ffe259, #ffa751);
}

.card-button-inactive {
  border-radius: 20px;
  background: #bdc3c7;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #bdc3c7, #2c3e50);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #bdc3c7, #2c3e50);
}

.card {
  width: 100%;
}

.card-content {
  padding: 0 1.5rem;
  padding-bottom: 20px;
}

.card-image {
  padding-top: 20px;
}

.media-content {
  overflow: hidden;
}

.is-2by1 {
  width: 80px;
  margin: 0 auto;
}

[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"]+label {
  background: #f15d22;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-weight: 600;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;

  &:hover {
    background-color: darken(#f15d22, 10%);
  }

  &.btn-2 {
    background-color: #99c793;
    border-radius: 50px;
    overflow: hidden;

    &::before {
      color: #fff;
      content: "\f382";
      font-family: "Font Awesome 5 Pro";
      font-size: 100%;
      height: 100%;
      right: 130%;
      line-height: 3.3;
      position: absolute;
      top: 0px;
      transition: all 0.3s;
    }

    &:hover {
      background-color: darken(#99c793, 30%);

      &::before {
        right: 75%;
      }
    }
  }
}

.button-color {
  background: #f15d22;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: 'Poppins', sans-serif;
  font-size: inherit;
  font-weight: 600;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  padding-bottom: 3rem;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;

  &:hover {
    background-color: darken(#f15d22, 10%);
  }

  &.btn-1 {
    background-color: #f79159;
    box-shadow: 0 6px darken(#f79159, 10%);
    transition: none;

    &:hover {
      box-shadow: 0 4px darken(#f79159, 10%);
      top: 2px;
    }
  }

  &.btn-2 {
    background-color: #99c793;
    border-radius: 50px;
    overflow: hidden;

    &::before {
      color: #fff;
      content: "\f382";
      font-family: "Font Awesome 5 Pro";
      font-size: 100%;
      height: 100%;
      right: 130%;
      line-height: 3.3;
      position: absolute;
      top: 0px;
      transition: all 0.3s;
    }

    &:hover {
      background-color: darken(#99c793, 30%);

      &::before {
        right: 75%;
      }
    }
  }

  &.btn-3 {
    background-color: #ee6d9e;
    border-radius: 0;
    overflow: hidden;

    span {
      display: inline-block;
      height: 100%;
      transition: all 0.3s;
      width: 100%;
    }

    &::before {
      color: #fff;
      content: "\f382";
      font-family: "Font Awesome 5 Pro";
      font-size: 130%;
      height: 100%;
      left: 0;
      line-height: 2.6;
      position: absolute;
      top: -180%;
      transition: all 0.3s;
      width: 100%;
    }

    &:hover {
      background-color: darken(#ee6d9e, 30%);

      span {
        transform: translateY(300%);
      }

      &::before {
        top: 0;
      }
    }
  }
}
</style>
